import { Card, FormGroup } from '@themesberg/react-bootstrap';
import React, { useEffect, useState } from 'react';
import { fetchApi, postApi } from '../../../redux/api';
import CustomTable from '../../../components/CustomTable';
import { Table, Input, Label, Button } from 'reactstrap';
import SearchInput from '../../../components/SearchInput';
import './AcctChartOpeninBal.css';
import { formatNumber } from '../../../redux/utils';

const AcctChartOpeninBal = () => {
    const [account_type, setAccount_type] = useState([]);
    const [selectedType, setSelectedType] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const getAcctypes = (type) => {
        fetchApi(`tsa-code?types=opening_balance&&mda_code=${type}`)
            .then((d) => {
                if (d.results) {
                    setAccount_type(d.results);
                } else {
                    setAccount_type([]);
                }
            })
            .catch((err) => {
                console.log(err);
                setAccount_type([]);
            });
    };

    useEffect(() => {
        getAcctypes();
    }, []);

    const handleTypeChange = (e) => {
        setSelectedType(e.target.value);
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
    };

    const filteredAccounts = account_type.filter(account => {
        const matchesSearchTerm = account.description.toLowerCase().includes(searchTerm.toLowerCase()) || 
                                  account.head.toLowerCase().includes(searchTerm.toLowerCase()) || 
                                  account.account_type.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesSelectedType = selectedType ? account.account_type === selectedType : true;

        return matchesSearchTerm && matchesSelectedType;
    });

    const fields = [
        {
            title: "Description",
            custom: true,
            component: (i) => {
                const text = i.description.split(" ");
                return (
                    <span style={{ width: "250px" }}>
                        {text.slice(0, 10).join(" ")}{text.length > 10 ? "..." : ""}
                    </span>
                );
            }
        },
        {
            title: "Head",
            value: "head"
        },
        {
            title: "Account Type",
            value: "account_type"
        },
        {
            title: "Asset/Expenses",
            custom: true,
            component: (i, index) => (
                i.account_type === "Fixed Asset" || i.account_type === "Intangible Asset" || i.account_type === "Cash" || i.account_type === "Inventory" || i.account_type === "Account Recievables" || i.account_type === "Investments" || i.account_type === "Expenses" ? (
                    <Input type="number" />
                ) : null
            )
        },
        {
            title: "Liabilities",
            custom: true,
            component: (i, index) => (
                i.account_type === "Account Payables" || i.account_type === "Short Term Borrowing" || i.account_type === "Long Term Borrowing" || i.account_type === "Equity" || i.account_type === "Provision" || i.account_type === "Revenue/Income" ? <Input type="number" /> : null
            )
        },
    ];

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleDescription = () => setIsExpanded(!isExpanded);

    const handleChange = (account, type, value) => {
        setAccount_type(prevState => {
            return prevState.map(acc => {
                if (acc.head === account.head) {
                    return {
                        ...acc,
                        [type]: parseFloat(value) || 0
                    };
                }
                return acc;
            });
        });
    };

    const calculateTotals = () => {
        return account_type.reduce((totals, account) => {
            totals.debit += account.dr || 0;
            totals.credit += account.cr || 0;
            return totals;
        }, { debit: 0, credit: 0 });
    };

    const { debit, credit } = calculateTotals();


    const handleSubmit = () => {
postApi("post-bal-entry",{openingbal:account_type})
.then((resp)=>{if(resp.success){
    alert("success")
}})
    };

    return (
        <div>
            <h2 style={{ textAlign: "center", margin: "20px 0" }}>Account Chart Opening Balances</h2>
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Body>
                <div style={{ marginBottom: "20px" ,float:"right"}}>
                        <div>
                            <strong>Total Asset: </strong>{formatNumber(debit)}
                        </div>
                        <div>
                            <strong>Total Liabilities/Equity: </strong>{formatNumber(credit)}
                        </div>
                        <div>
                            <strong>Balancing Figure: </strong>{formatNumber(debit - credit)}
                        </div>
                    </div>
                    <div className='row'>

                
                    <FormGroup className='col-md-6'>
                        <Label for="accountTypeFilter">Filter by Account Type</Label>
                        <Input type="select" id="accountTypeFilter" onChange={handleTypeChange} value={selectedType}>
                            <option value="">All</option>
                            {Array.from(new Set(account_type.map(item => item.account_type))).map((type, index) => (
                                <option key={index} value={type}>{type}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup className='col-md-6'>
                        <Label for="accountTypeFilter">Date</Label>
                        <Input type="date" >
                            
                        </Input>
                    </FormGroup>
                    </div>
                    
                    {/* {account_type?.length} */}
                    <SearchInput value={searchTerm} onChange={handleSearch} />
              
                    <Table bordered striped style={{ margin: "20px 0", width: "100%", tableLayout: "fixed" }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: "left" }}>Description</th>
                                <th style={{ textAlign: "left" }}>Head</th>
                                <th style={{ textAlign: "left" }}>Account Type</th>
                                <th style={{ textAlign: "left" }}>Assets</th>
                                <th style={{ textAlign: "left" }}>Liabilities/Equity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredAccounts.length > 0 ? filteredAccounts.map((item) => {
                                return (
                                    <tr key={item.head}>
                                        <td style={{ width: "20%", padding: "10px" }}>
                                            {isExpanded ? item.description : `${item.description.substring(0, 20)}`}
                                            {item.description.length > 30 && (
                                                <span onClick={toggleDescription} style={{ color: 'blue', cursor: 'pointer' }}>
                                                    {isExpanded ? '...' : '..'}
                                                </span>
                                            )}
                                        </td>
                                        <td style={{ padding: "10px" }}>{item.head}</td>
                                        <td style={{ padding: "10px" }}>{item.account_type}</td>
                                        <td style={{ padding: "10px" }}>
                                            {item.account_type === "Fixed Asset" || item.account_type === "Intangible Asset" || item.account_type === "Cash" || item.account_type === "Inventory" || item.account_type === "Account Recievables" || item.account_type === "Investments" || item.account_type === "Expenses" ? 
                                                <>
                                                    <Label>({formatNumber(item?.dr || 0.00)})</Label>
                                                    <Input 
                                                        type="number" 
                                                        style={{ width: "100%" }} 
                                                        value={item.dr || ''}
                                                        onChange={(e) => handleChange(item, 'dr', e.target.value)}
                                                    />
                                                </>
                                            : null}
                                        </td>
                                        <td style={{ padding: "10px" }}>
                                            {item.account_type === "Account Payables" || item.account_type === "Short Term Borrowing" || item.account_type === "Long Term Borrowing" || item.account_type === "Equity" || item.account_type === "Provision" || item.account_type === "Revenue/Income" ? 
                                                <>
                                                    <Label>({formatNumber(item?.cr || 0.00)})</Label>
                                                    <Input 
                                                        type="number" 
                                                        style={{ width: "100%" }} 
                                                        value={item.cr || ''}
                                                        onChange={(e) => handleChange(item, 'cr', e.target.value)}
                                                    />
                                                </>
                                            : null}
                                        </td>
                                    </tr>
                                );
                            }) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>No accounts found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <Button onClick={handleSubmit} color="primary">Submit</Button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}

export default AcctChartOpeninBal;
